const env = {
    production: false,
    api: {
        host: 'https://api-retcercano-dev.ripley.com.pe/auth',
        x_api_key: 'ZETfsMLquY9VUzKwewJsQv4I413wIwdEzFlR9B20',
    },
    recaptcha: {
        webKey: "6LcTr_YcAAAAAKnsseyQVSnkgpQM5FnRKgkG52bK"
    }
  }
  
  export default env;